import { render, staticRenderFns } from "./SolicitarDespachos.vue?vue&type=template&id=10078161&scoped=true"
import script from "./SolicitarDespachos.vue?vue&type=script&lang=js"
export * from "./SolicitarDespachos.vue?vue&type=script&lang=js"
import style0 from "./SolicitarDespachos.vue?vue&type=style&index=0&id=10078161&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10078161",
  null
  
)

export default component.exports